import { useMutation, useQuery } from "@apollo/client";
import { useRecoilValue } from "recoil";

import { TLoadoutsQuery } from "MVVM/Views/CreateMontage/@types";
import {
  LOADOUT_QUERY,
  ME_QUERY,
  QUICK_EDIT_GET_MOMENT,
} from "MVVM/GraphQL/quickEdit";
import { MOMENT_CREATE_CLIP } from "MVVM/GraphQL/mutations/momentRequestClip";
import { IQuickEditMoment } from "./@types";
import { IN_CAMPAIGN } from "MVVM/GraphQL/competitions";
import { ActiveCampaign } from "MVVM/State/campaign";
import { useMemo } from "react";

export const QuickEditViewModel = (momentId: string) => {
  const activeCampaign = useRecoilValue(ActiveCampaign);
  const { data: loadoutsData } = useQuery<TLoadoutsQuery>(LOADOUT_QUERY, {
    variables: {
      game: 7302,
      type: "quick_edit",
    },
  });
  const { data: momentData } = useQuery<{ moment: IQuickEditMoment }>(
    QUICK_EDIT_GET_MOMENT,
    {
      variables: { id: momentId },
      skip: !momentId,
    },
  );

  const { data } = useQuery(IN_CAMPAIGN, {
    skip: !activeCampaign.slug,
    variables: { campaign: activeCampaign.slug },
  });

  const { data: viewerData } = useQuery<{
    me: {
      mediaUploadUrl: {
        fields: {
          name: string;
          value: string;
        }[];
        key: string;
        url: string;
      };
    };
  }>(ME_QUERY, {
    fetchPolicy: "network-only",
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
  });

  const campaignAlert = useMemo(() => {
    const matchPlayedAt = momentData?.moment?.match?.matchPlayedAt;
    let displayAlert = false;
    let dayAgeAllowed = 0;

    if (matchPlayedAt && activeCampaign?.matchDocumentTtlHours) {
      dayAgeAllowed = activeCampaign.matchDocumentTtlHours / 24;
      const cutoff = new Date(
        Date.now() - activeCampaign.matchDocumentTtlHours * 60 * 60 * 1000,
      );
      displayAlert = new Date(matchPlayedAt) < cutoff;
    }
    if (!displayAlert) return null;

    return `This moment is older than ${dayAgeAllowed} day${
      dayAgeAllowed > 1 ? "s" : ""
    } and is not eligible for the ${
      activeCampaign.campaign
    } competition. Your score on the leaderboard wiill not change as a result. `;
  }, [
    activeCampaign?.matchDocumentTtlHours,
    momentData?.moment?.match?.matchPlayedAt,
    activeCampaign.campaign,
  ]);

  const loadouts = loadoutsData?.loadouts;
  const moment = momentData?.moment;
  const mediaUploadUrl = viewerData?.me.mediaUploadUrl;

  return {
    loadouts,
    moment,
    momentCreateClip,
    mediaUploadUrl,
    campaignAlert,
  };
};
